<div class="container">
  <div class="card mt-3">
    <div class="card-body">
      <patron-tabview [tabs]="tabs" (tabChanged)="tabChanged($event)">
        <ng-template #profileTab>
          <div class="row d-flex justify-content-center py-5">
            <div class="col-xl-5 col-lg-6 col-md-8">
              <patron-form [formGroup]="formGroup">
                <patron-form-field label="Email" [formGroup]="formGroup" formControlName="email">
                </patron-form-field>

                <patron-form-field label="Nome" [formGroup]="formGroup" formControlName="name">
                </patron-form-field>
              </patron-form>
            </div>
          </div>
        </ng-template>
        <ng-template #sessionsTab>
          <app-my-sessions #mySessions></app-my-sessions>
        </ng-template>
      </patron-tabview>
    </div>
  </div>
</div>
